<template>
  <!-- :class="[isActive ? 'activeClass' : ' ', 'errorClass']" -->
  <div :class="[samllButtonSize ? 'smallpagination' : 'pagination']">
    <el-pagination
      class="is-front-page"
      background
      :current-page="pageNum"
      :page-sizes="page.pageSizes"
      :page-size="page.pageSize"
      layout="total"
      :pager-count="pagerCount"
      :total="total"
      @size-change="sizeChange"
      @current-change="currentChange"
    >
      <el-button
        :class="pageNum == 1 ? 'page-is-front' : ''"
        class="paginat-front-btn el-icon-d-arrow-left"
        @click="pageGoFront"
      />
    </el-pagination>
    <el-pagination
      background
      :current-page="pageNum"
      :page-sizes="page.pageSizes"
      :page-size="page.pageSize"
      layout="prev, pager, next,  sizes, jumper"
      :pager-count="pagerCount"
      :total="total"
      @size-change="sizeChange"
      @current-change="currentChange"
    >
      <el-button
        :class="pageNum * page.pageSize >= total ? 'page-is-last' : ''"
        class="paginat-front-btn el-icon-d-arrow-right"
        @click="pageGoLast"
      />
    </el-pagination>
  </div>
</template>

<script>
export default {
  props: {
    samllButtonSize: {
      type: Boolean,
      default: () => false
    },
    pageSizes: {
      type: Array,
      default: () => [10, 20, 50, 100]
    },
    pageSize: {
      type: Number,
      default: 10
    },
    pageNum: {
      type: Number,
      default: 1
    },
    total: {
      type: Number,
      default: 100
    },
    pagerCount: {
      type: Number,
      default: 7
    },
    layout: {
      type: String,
      default: 'total, prev, pager, next, sizes, jumper'
    }
  },
  data() {
    return {
      page: {
        pageSizes: [10, 20, 50, 100],
        pageSize: 10
      }
    }
  },
  watch: {
    pageSize: {
      handler(val) {
        this.page.pageSize = val
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {
    // console.log("pageSizes"+this.pageSizes)
    // 下面代码是初始化值，会导致使用该分页器的组件在掉接口的时候，触发分页器的方法，调用两次接口
    // this.sizeChange(10)
    this.page.pageSizes = this.pageSizes
    this.page.pageSize = this.pageSize
  },
  methods: {
    sizeChange(val) {
      this.page.pageSize = val
      this.$emit('sizeChange', val)
    },
    currentChange(val) {
      this.$emit('currentChange', val)
    },
    pageGoFront() {
      // eslint-disable-next-line eqeqeq
      if (this.pageNum == 1) return
      this.$emit('currentChange', 1)
    },
    pageGoLast() {
      if (this.pageNum * this.page.pageSize >= this.total) return
      this.$emit('currentChange', Math.ceil(this.total / this.page.pageSize))
    }
  }
}
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
.pagination {
  display: block;
  text-align: right;
  margin-top: 20px;
  /deep/ .el-pagination {
    .number {
      font-weight: 400;
      background: #fff;
      border-radius: 2px;
      border: 1px solid #d9d9d9;
    }
    .el-icon-more,
    .btn-prev,
    .btn-next {
      font-weight: 300;
      background: #fff;
      border-radius: 2px;
      border: 1px solid #d9d9d9;
    }
  }
  // 分页ui修改
  /deep/ .el-pagination__jump {
    margin-left: -5px !important;
  }
  /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
    border: 1px solid $wit-primary;
  }
  /deep/ .el-pager li,
  /deep/ .is-background .el-pager li {
    min-width: 32px;
    height: 32px;
    line-height: 32px;
    margin: 0 4px;
  }
  /deep/.el-input--mini .el-input__inner {
    height: 32px !important;
    line-height: 32px !important;
  }
  /deep/ .el-pagination__editor.el-input .el-input__inner {
    height: 32px;
    line-height: 32px;
    min-width: 48px;
  }
  /deep/ .el-pagination button {
    min-width: 32px;
    height: 32px;
    line-height: 32px;
  }
  /deep/ .el-pagination span:not([class*="suffix"]) {
    height: 32px;
    line-height: 32px;
  }
  /deep/.el-pagination .el-select .el-input {
    width: 88px;
  }
  /deep/ .el-pagination__total {
    margin-right: 12px;
  }
  /deep/ .el-pagination.is-background .btn-prev {
    margin: 0 4px;
  }
}
.paginat-front-btn {
  margin: 0 5px;
  background-color: #f4f4f5;
  color: #606266;
  min-width: 30px;
  border-radius: 2px;
  display: inline-block;
  text-align: center;
  cursor: pointer;
  span {
    min-width: 20px;
  }
}
.page-is-front {
  cursor: not-allowed;
  color: #c0c4cc;
  &:hover {
    color: #c0c4cc !important;
  }
}
.page-is-last {
  cursor: not-allowed;
  color: #c0c4cc;
  &:hover {
    color: #c0c4cc !important;
  }
}
/deep/ .el-pagination {
  display: inline-block;
}
.is-front-page {
  padding-right: 0;
  margin-right: -5px;
}
/deep/ .el-pagination {
  .el-input__inner:hover {
    color: #409eff !important;
    border: 1px solid #d9d9d9 !important;
  }
}
.smallpagination {
  display: block;
  text-align: right;
  margin-top: 15px;
  /deep/ .el-pagination {
    .number {
      font-weight: 400;
      background: #fff;
      border-radius: 2px;
      border: 1px solid #d9d9d9;
    }
    .el-icon-more,
    .btn-prev,
    .btn-next {
      font-weight: 300;
      background: #fff;
      border-radius: 2px;
      border: 1px solid #d9d9d9;
    }
  }

  // 分页ui修改
  /deep/ .el-pagination__jump {
    margin-left: -5px !important;
  }
  /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
    border: 1px solid #409eff;
  }
  /deep/ .el-pager li,
  /deep/ .is-background .el-pager li {
    min-width: 28px;
    height: 28px;
    line-height: 28px;
    margin: 0 4px;
  }
  /deep/.el-input--mini .el-input__inner {
    height: 28px !important;
    line-height: 28px !important;
  }
  /deep/ .el-pagination__editor.el-input .el-input__inner {
    height: 28px;
    line-height: 28px;
    min-width: 48px;
  }
  /deep/ .el-pagination button {
    min-width: 28px;
    height: 28px;
    line-height: 28px;
  }
  /deep/ .el-pagination span:not([class*="suffix"]) {
    height: 28px;
    line-height: 28px;
  }
  /deep/.el-pagination .el-select .el-input {
    width: 88px;
  }
  /deep/ .el-pagination__total {
    margin-right: 12px;
  }
  /deep/ .el-pagination.is-background .btn-prev {
    margin: 0 4px;
  }
}
.paginat-front-btn {
  margin: 0 5px;
  background-color: #f4f4f5;
  color: #606266;
  min-width: 30px;
  border-radius: 2px;
  display: inline-block;
  text-align: center;
  cursor: pointer;
  span {
    min-width: 20px;
  }
}

body.sys-deep-style {
  .pagination {
    /deep/ .el-pagination {
      .number {
        background: unset;
        border-color: #4b4e4c;
      }
      .el-icon-more,
      .btn-prev,
      .btn-next {
        background: unset;
        border-color: #4b4e4c;
      }
    }
  }
}
</style>
